import { render } from "./manage-service-product.vue?vue&type=template&id=d8c06b52"
import script from "./manage-service-product.vue?vue&type=script&lang=js"
export * from "./manage-service-product.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__